<main class="auth-page">
  <!-- Left — form column -->
  <div class="auth-form-col">
    <div class="auth-topbar">
      <div class="auth-logo">
        <a href="/" class="auth-logo__tile">
          <i class="bi bi-mortarboard-fill"></i>
        </a>
        <span class="auth-logo__wordmark" dir="rtl">منصتي</span>
      </div>
      <app-lang-toggle></app-lang-toggle>
    </div>

    <!-- Validating the link -->
    <div *ngIf="checking" class="text-center py-4">
      <span class="spinner-border"></span>
      <p class="auth-sub mt-3 mb-0">{{ "auth.ValidatingLink" | translate }}</p>
    </div>

    <!-- Invalid / expired link -->
    <ng-container *ngIf="!checking && !tokenValid">
      <div class="auth-icon-tile auth-icon-tile--blue"><i class="bi bi-link-45deg"></i></div>
      <h1 class="auth-title">{{ "auth.LinkExpired" | translate }}</h1>
      <p class="auth-sub">{{ "auth.LinkExpiredDesc" | translate }}</p>
      <a [routerLink]="['/account/forget-password']" class="auth-btn auth-btn--primary">
        <i class="bi bi-envelope"></i>{{ "auth.RequestNewLink" | translate }}
      </a>
    </ng-container>

    <!-- Success -->
    <ng-container *ngIf="!checking && tokenValid && done">
      <div class="auth-icon-tile auth-icon-tile--green"><i class="bi bi-check-circle"></i></div>
      <h1 class="auth-title">{{ "auth.ResetSuccess" | translate }}</h1>
      <p class="auth-sub">{{ "auth.ResetSuccessDesc" | translate }}</p>
      <a [routerLink]="['/account/login']" class="auth-btn auth-btn--primary">
        <i class="bi bi-person"></i>{{ "auth.ContinueToLogin" | translate }}
      </a>
    </ng-container>

    <!-- Reset form -->
    <ng-container *ngIf="!checking && tokenValid && !done">
      <div class="auth-icon-tile auth-icon-tile--violet"><i class="bi bi-key"></i></div>
      <h1 class="auth-title">{{ "auth.ResetHeading" | translate }}</h1>
      <p class="auth-sub">
        {{ "auth.ResetDescription" | translate }}<ng-container *ngIf="maskedEmail"> ({{ maskedEmail }})</ng-container>.
      </p>

      <form class="auth-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div>
          <label class="form-label">{{ "auth.NewPassword" | translate }}</label>
          <div class="auth-input-wrap">
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              formControlName="password"
              [placeholder]="'auth.NewPasswordPlaceholder' | translate"
            />
            <button type="button" class="auth-input-wrap__eye" (click)="togglePassword()"
              [attr.aria-label]="'app.ShowPassword' | translate">
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
          <div class="auth-hint auth-hint--error"
            *ngIf="pwLen > 0 && form.get('password')?.invalid">
            <i class="bi bi-exclamation-triangle"></i>{{ "auth.PasswordRule" | translate }}
          </div>
          <div class="auth-strength" *ngIf="pwLen >= 8">
            <span [class]="'on--' + pwStrength"></span>
            <span [ngClass]="pwLen >= 11 ? 'on--' + pwStrength : ''"></span>
            <span [ngClass]="pwLen >= 14 ? 'on--' + pwStrength : ''"></span>
            <span [ngClass]="pwLen >= 17 ? 'on--' + pwStrength : ''"></span>
            <small>{{ strengthKey | translate }}</small>
          </div>
        </div>

        <div>
          <label class="form-label">{{ "auth.ConfirmNewPassword" | translate }}</label>
          <input
            type="password"
            class="form-control"
            formControlName="confirmPassword"
            [placeholder]="'auth.ConfirmNewPasswordPlaceholder' | translate"
          />
          <div class="auth-hint auth-hint--error"
            *ngIf="form.errors?.['mismatch'] && form.get('confirmPassword')?.touched">
            <i class="bi bi-exclamation-triangle"></i>{{ "auth.PasswordMismatch" | translate }}
          </div>
          <div class="auth-hint auth-hint--ok"
            *ngIf="!form.errors?.['mismatch'] && (form.get('confirmPassword')?.value?.length ?? 0) > 0">
            <i class="bi bi-check-circle"></i>{{ "auth.PasswordsMatch" | translate }}
          </div>
        </div>

        <button type="submit" class="auth-btn auth-btn--violet" [disabled]="form.invalid || isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
          <i *ngIf="!isSubmitting" class="bi bi-key"></i>{{ "auth.ResetPassword" | translate }}
        </button>

        <a [routerLink]="['/account/login']" class="auth-btn auth-btn--ghost">
          <i class="bi bi-arrow-left auth-btn__back"></i>{{ "auth.BackToLogin" | translate }}
        </a>
      </form>
    </ng-container>
  </div>

  <!-- Right - immersive panel (shared) -->
  <app-auth-hero [compact]="true"></app-auth-hero>
</main>
